{
  "screen": {
    "sectionHeading": "Avdelning och vårdplats",
    "open": "Flytta patient",
    "heading": "Flytta patient",
    "explanation": "Flyttar patienten till en annan avdelning eller vårdplats. Det är samma vårdtillfälle, så inskrivningstiden ändras inte.",
    "from": "Patienten ligger nu på {location}, sedan {since}.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "final": "En flytt kan inte tas bort. Den nuvarande placeringen finns kvar i journalen. Blev det fel, flytta patienten igen.",
    "save": "Flytta patienten",
    "saving": "Flyttar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "saved": "Patienten är flyttad till {ward}.",
    "discardQuestion": "Stäng formuläret? Patienten flyttas inte.",
    "discardConfirm": "Stäng utan att flytta",
    "discardCancel": "Fortsätt fylla i"
  },
  "field": {
    "ward": "Till avdelning",
    "bed": "Vårdplats",
    "movedAt": "Flyttad"
  },
  "fieldHint": {
    "ward": "Avdelningen patienten flyttas till. Samma avdelning går också, för att byta vårdplats.",
    "bed": "Rum och plats som personalen säger dem. Lämna tomt om det inte finns någon plats — patienten står då sist i avdelningslistan, utan plats.",
    "movedAt": "När flytten skedde, som ÅÅÅÅ-MM-DD TT:MM med 24-timmarsklocka. Ändra om flytten skedde tidigare än nu, men inte före {since}."
  },
  "refusal": {
    "wardMissing": "Välj vilken avdelning patienten flyttas till. Patienten flyttades inte.",
    "wardNotFound": "Avdelning {ward} finns inte i journalen. Patienten flyttades inte.",
    "fieldTooLong": "Vårdplatsen är för lång. Korta ner till högst {max} tecken. Patienten flyttades inte.",
    "movedAtMissing": "Fyll i när flytten skedde. Patienten flyttades inte.",
    "movedAtMalformed": "Tiden för flytten läses inte som en tidpunkt. Skriv den som ÅÅÅÅ-MM-DD TT:MM, till exempel 2026-10-15 08:00. Patienten flyttades inte.",
    "movedAtInFuture": "Tiden för flytten ligger i framtiden. Patienten flyttades inte.",
    "beforeCurrent": "Flytten kan inte ha skett före {since}, när patienten kom till sin nuvarande plats. Patienten flyttades inte.",
    "noChange": "Patienten ligger redan där. Välj en annan avdelning eller vårdplats. Patienten flyttades inte.",
    "stale": "Någon annan har flyttat patienten medan formuläret var öppet. Översikten är uppdaterad — kontrollera var patienten ligger nu och försök igen. Patienten flyttades inte.",
    "notActive": "Patienten är inte inskriven längre och kan inte flyttas. Patienten flyttades inte.",
    "notFound": "Vårdtillfället finns inte i journalen. Öppna patientöversikten igen. Patienten flyttades inte.",
    "roleMayNotDocument": "Din roll får inte dokumentera i journalen. Patienten flyttades inte.",
    "unknown": "Patienten flyttades inte. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Det är inte säkert om patienten flyttades — öppna patientöversikten igen och se var patienten ligger innan du försöker igen."
  }
}
